import React,{useEffect,useState} from 'react'
import Questions_Table from "../questionnaire_custom_answers"
import data from "./pspdata/clinical_psp.json"
import  diagnostic from "./pspdata/degrees_diagnostic_certainty.json"
import {Table,Form,Col} from 'react-bootstrap'
import DiagnosticTable from "./psp_diagnostic_table"
import ScrollToTop from "../../../../utilities/scroll_to_top/scroll_to_top"
import Title from "../../../../utilities/other/title"
import data_B1 from './pspdata/clinical_psp_B1.json'
import data_B2 from "./pspdata/clinical_psp_B2.json"
import data_B2_B3 from './pspdata/clinical_psp_B3.json'
function ClinicalPSP(props){
    const handler = (event) =>{
        props.handler("clinical_psp",event)
    }
   
    return(
        <div>
                <Title>{props.title}</Title>
                <Questions_Table  YesNoLabel={"Fill all"} autoFilldata={true} title= 'fab' score={false}  autoFill={props.handlePspMsaAuto} 
                questions={data_B1} data={props.data} disabled={props.edit} answers={data_B1}  handler={handler} />
                {/* <Questions_Table customAnswers={["","No"]} hideHeader={true} YesNoLabel={"Fill all"} autoFilldata={true} title= 'fab' score={false}  autoFill={props.handlePspMsaAuto} 
                questions={data_B2} data={props.data} disabled={props.edit} answers={data_B2}  handler={handler} /> */}
                <Questions_Table  hideHeader={true} customAnswers={["","No"]}YesNoLabel={"Fill all"} autoFilldata={true} title= 'fab' score={false}  autoFill={props.handlePspMsaAuto} 
                questions={data_B2_B3} data={props.data} disabled={props.edit} answers={data_B2_B3}  handler={handler} />
               <Questions_Table  hideHeader={true} score={false}  autoFill={props.handlePspMsaAuto} questions={data} data={props.data} disabled={props.edit} answers={data} handler={handler} />
               
               <DiagnosticTable handler={handler} data={props.data} edit={props.edit}/>
               
        </div>
    )
}

export default ClinicalPSP